import { css } from "@emotion/css";
import styled from "@emotion/styled";

export const triggerButton = css`
    &.sds-base-button.ant-btn {
        position: fixed;
        z-index: 999;
        right: 10px;
        bottom: 10px;

        display: flex;
        align-items: center;
        justify-content: center;

        opacity: 0.5;
    }
`;

export const TriggerText = styled.div`
    margin: 0;
    font-size: 10px;
`;
